import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=5e60833a&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=5e60833a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e60833a",
  null
  
)

export default component.exports